export enum GroupPermissionType {
  Base = 'base',
  Current = 'curr',
}

export enum PermissionGroupPrefix {
  Generic = 'CPG_',
  Class = 'CL_',
}

/** Whether a group was made by hand or belongs to a class, read from its id's prefix. */
export enum PermissionGroupType {
  Custom = 'custom',
  Class = 'class',
}
